import { isUndefined } from "./utils.ts";

type LogLevel = "log" | "debug" | "info" | "warn" | "error";

const LEVELS: LogLevel[] = ["log", "debug", "info", "warn", "error"];

type ConsoleInterface = Record<LogLevel, (...args: unknown[]) => void>;

const getConsole = (cons?: Partial<ConsoleInterface>): ConsoleInterface => {
  if (isUndefined(cons) || cons == null) {
    const f = () => null;
    const out: ConsoleInterface = {
      log: f,
      debug: f,
      info: f,
      warn: f,
      error: f
    };
    return out;
  }
  return cons as ConsoleInterface;
};

/**
 * Custom Logger with Polyfill
 */
export default class Logger {
  static _console: ConsoleInterface = getConsole();
  static _enabled = false;
  static _level: LogLevel = "error";

  static set enabled(value: boolean) {
    Logger._enabled = value;
  }

  static set level(value: string) {
    Logger._level = value as LogLevel;
  }

  static set console(console: Partial<ConsoleInterface>) {
    Logger._console = getConsole(console);
  }

  private static _render =
    (currentLogType: LogLevel) =>
    (...args: unknown[]): void => {
      const canLog =
        LEVELS.indexOf(currentLogType) >= LEVELS.indexOf(Logger._level);
      if (Logger._enabled && canLog) {
        Logger._console[currentLogType].apply(Logger._console, args);
      }
    };

  static log = Logger._render("log");
  static info = Logger._render("info");
  static debug = Logger._render("debug");
  static warn = Logger._render("warn");
  static error = Logger._render("error");
}
